import { useEffect } from 'react'
import './App.css';
import Navbar from './components/Navbar.js'
import MainSection from './components/MainSection.js'
import AboutMe from './components/AboutMe.js'
import ContactMe from './components/ContactMe.js'
import Projects from './components/Projects.js'
import Work from './components/Work.js'
import { Routes, Route, Navigate } from 'react-router-dom'

function App() {

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route element={<MainSection />} path="/" />
        <Route element={<AboutMe />} path="/about" />
        <Route element={<Projects />} path="/projects" />
        <Route element={<Work />} path="/work" />
        <Route element={<ContactMe />} path="/contact" />
      </Routes>
      <footer className="site-footer">
        <div className="footer-content">
          <p>Built by Nick Amenda</p>
          <p>© 2025 Nick Amenda. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
